module.exports = __webpack_public_path__ + "static/media/blue-on-light@3x.9f75731a.png";